import {MyopMessages} from "../../common/MyopMessages";
import {myopAttributes} from "../../consts";
import {HostSDK} from "../../host/hostSDK";
import {CreateRefComponentMessage, RefComponentCreatedMessage} from "../../messages/CreateRefComponentMessage";
import {BaseWebComponentMessageHandler, MessageToHost} from "./BaseWebComponentMessageHandler";
import {ShadowRootRef} from "../shadowRootRef";
import {IMyopComponent} from "../../host";

export class CreateRefComponentMessageHandler extends BaseWebComponentMessageHandler<CreateRefComponentMessage> {

    messageType = MyopMessages.CreateRefComponentMessage;

    innerExecutor = (event: CreateRefComponentMessage, shadowRootRef: ShadowRootRef, messageToHost: MessageToHost) => {

        const createRef = async () => {
            //const allItems = shadowRootRef.shadowRoot.querySelectorAll<HTMLElement>(`[${myopAttributes.id}='${event.ref?.refConfig.selector}']`);
            const allItems = shadowRootRef.shadowRoot.querySelectorAll<HTMLElement>(`[${myopAttributes.id}='${event.refConfig.selector}']`);

            if (allItems.length === 1) {
                const hostSDK = HostSDK.Instance();

                const refComponent = hostSDK.components.find(c => c.id === event.options.id)!;
                if (refComponent) {
                    ////>>>>
                    refComponent.dispose();
                } else {
                  //  console.log(`failed to find ${event.options.id} in mem scope`, hostSDK);
                }
                //we have the ref component in our HostSDK (same memory when using webcomponent)
                //  refComponent.parent = implementationComponent;
                //delete the ref component
                const index = hostSDK.components.indexOf(refComponent);
                if (index !== -1) {
                    hostSDK.components.splice(index, 1);
                    //console.log('createRefComponent called removed temp ref component');
                } else {
                    //console.log('createRefComponent called using temp ref component');
                }

                const implementationComponent = await hostSDK.loadComponent(event.nestedComponentConfig,
                    allItems.item(0),
                    event.options)

                //TODO : no need this, pass options from parent
                //implementationComponent.id = event.predefinedId;
                //refComponent.id += '.';

                //TODO : not really needed ?
                // await implementationComponent.initiated();

                const nestedRefConfig: any[] = [];

                Object.keys(implementationComponent.refs).forEach(refName => {
                    let ref = implementationComponent.refs[refName];
                    ref = ref.__nonProxied || ref;

                    if ((ref as IMyopComponent).componentDefinition) {
                        nestedRefConfig.push({
                            refName,
                            componentDefinitionId: (ref as IMyopComponent).componentDefinition.id,
                        });
                    }
                })

                messageToHost(new RefComponentCreatedMessage(event.handlerUniqueId, nestedRefConfig));
            } else {
                console.error('CreateRefComponentMessageHandler - DOM element not found')
                this.messageToHost(new RefComponentCreatedMessage(event.handlerUniqueId, [], true));

                debugger;
            }
        }

        createRef().then()
        //returning undefined so it won't act as a cleanup
    }
}
